/**
 * Fiskal Cloud Usage API
 * # Overview Retrieve usage reports for billing.  # Usage The export of reporting data can be triggered on tenant, organization or business premises level. In addition an overall usage report based on customer Identifier (from billing system) or for all customers can be requested.  Report is always based on a specific month.  ## Getting an authentication token  To be able to work with the API you need to get an authentication token to use with all subsequent API calls described below. Get the token via the [Oauth endpoint](https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token) of the Fiskal Cloud. Use client_id=df-api and grant_type=password for requesting a token. > The access token grants same access rights as the user has in the Fiskal Cloud Portal.  Example request to get token via curl: ``` curl -X POST \\ https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token \\ -H \'Accept: application/json\' \\ -H \'Content-Type: application/x-www-form-urlencoded\' \\ -d \'username=<USER_EMAIL_ADDRESS>&password=<USER_PASSWORD>&client_id=df-api&grant_type=password\' ``` Save the access_token entry of the response and pass it as bearer token in all subsequent API calls. Pass it as header parameter. ```\'Authorization: Bearer <ACCESS_TOKEN_FROM_AUTHENTICATION>\'```  For details on access tokens, please check general Oauth documentation like [Oauth.com](https://www.oauth.com/oauth2-servers/access-tokens/access-token-response/) 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { BusinessPremisesUsageContractDTO } from '../model/models';
import { CustomerUsageContractDTO } from '../model/models';
import { OrganizationUsageContractDTO } from '../model/models';
import { ReportStatusDTO } from '../model/models';
import { TenantUsageContractDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DeleteReportRequestParams {
    reportId: string;
}

export class ClsDeleteReportRequestParams {
    reportId: string = undefined;
}

export interface GenerateUsageBusinessPremisesRequestParams {
    usageMonth: string;
    businessPremisesId: string;
}

export class ClsGenerateUsageBusinessPremisesRequestParams {
    usageMonth: string = undefined;
    businessPremisesId: string = undefined;
}

export interface GenerateUsageCustomerByContractIdRequestParams {
    usageMonth: string;
    contractId: string;
}

export class ClsGenerateUsageCustomerByContractIdRequestParams {
    usageMonth: string = undefined;
    contractId: string = undefined;
}

export interface GenerateUsageOrganizationRequestParams {
    usageMonth: string;
    organizationId: string;
}

export class ClsGenerateUsageOrganizationRequestParams {
    usageMonth: string = undefined;
    organizationId: string = undefined;
}

export interface GenerateUsageTenantRequestParams {
    usageMonth: string;
    tenantId: string;
}

export class ClsGenerateUsageTenantRequestParams {
    usageMonth: string = undefined;
    tenantId: string = undefined;
}

export interface GetCSVReportUsageBusinessPremisesRequestParams {
    usageMonth: string;
    businessPremisesId: string;
}

export class ClsGetCSVReportUsageBusinessPremisesRequestParams {
    usageMonth: string = undefined;
    businessPremisesId: string = undefined;
}

export interface GetCSVReportUsageOrganizationRequestParams {
    usageMonth: string;
    organizationId: string;
}

export class ClsGetCSVReportUsageOrganizationRequestParams {
    usageMonth: string = undefined;
    organizationId: string = undefined;
}

export interface GetCSVReportUsageTenantRequestParams {
    usageMonth: string;
    tenantId: string;
}

export class ClsGetCSVReportUsageTenantRequestParams {
    usageMonth: string = undefined;
    tenantId: string = undefined;
}

export interface GetGeneratedCSVUsageCustomerByContractIdRequestParams {
    usageMonth: string;
    contractId: string;
}

export class ClsGetGeneratedCSVUsageCustomerByContractIdRequestParams {
    usageMonth: string = undefined;
    contractId: string = undefined;
}

export interface GetGeneratedUsageCustomerByContractIdRequestParams {
    usageMonth: string;
    contractId: string;
}

export class ClsGetGeneratedUsageCustomerByContractIdRequestParams {
    usageMonth: string = undefined;
    contractId: string = undefined;
}

export interface GetReportStatusUsageBusinessPremisesRequestParams {
    usageMonth: string;
    businessPremisesId: string;
}

export class ClsGetReportStatusUsageBusinessPremisesRequestParams {
    usageMonth: string = undefined;
    businessPremisesId: string = undefined;
}

export interface GetReportStatusUsageCustomerByContractIdRequestParams {
    usageMonth: string;
    contractId: string;
}

export class ClsGetReportStatusUsageCustomerByContractIdRequestParams {
    usageMonth: string = undefined;
    contractId: string = undefined;
}

export interface GetReportStatusUsageOrganizationRequestParams {
    usageMonth: string;
    organizationId: string;
}

export class ClsGetReportStatusUsageOrganizationRequestParams {
    usageMonth: string = undefined;
    organizationId: string = undefined;
}

export interface GetReportStatusUsageTenantRequestParams {
    usageMonth: string;
    tenantId: string;
}

export class ClsGetReportStatusUsageTenantRequestParams {
    usageMonth: string = undefined;
    tenantId: string = undefined;
}

export interface GetReportUsageBusinessPremisesRequestParams {
    usageMonth: string;
    businessPremisesId: string;
}

export class ClsGetReportUsageBusinessPremisesRequestParams {
    usageMonth: string = undefined;
    businessPremisesId: string = undefined;
}

export interface GetReportUsageOrganizationRequestParams {
    usageMonth: string;
    organizationId: string;
}

export class ClsGetReportUsageOrganizationRequestParams {
    usageMonth: string = undefined;
    organizationId: string = undefined;
}

export interface GetReportUsageTenantRequestParams {
    usageMonth: string;
    tenantId: string;
}

export class ClsGetReportUsageTenantRequestParams {
    usageMonth: string = undefined;
    tenantId: string = undefined;
}


export interface AdminReportApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Delete report
     * Delete report by report id 
* @param requestParameters
     */
    deleteReport(requestParameters: DeleteReportRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Generate a usage data report for a business premises
     * This function will generate usage data report for a business premises. 
* @param requestParameters
     */
    generateUsageBusinessPremises(requestParameters: GenerateUsageBusinessPremisesRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Generate a usage data report for the contract
     * This function will generate usage data report for the contract. 
* @param requestParameters
     */
    generateUsageCustomerByContractId(requestParameters: GenerateUsageCustomerByContractIdRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Generate a usage data report for an organization
     * This function will generate usage data report for an organization. 
* @param requestParameters
     */
    generateUsageOrganization(requestParameters: GenerateUsageOrganizationRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Generate a usage data report for a tenant.
     * This function will generate a usage data report for a selected tenant. 
* @param requestParameters
     */
    generateUsageTenant(requestParameters: GenerateUsageTenantRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Download a generated usage data CSV report for a business premises
     * Download a generated usage data CSV report for a business premises. 
* @param requestParameters
     */
    getCSVReportUsageBusinessPremises(requestParameters: GetCSVReportUsageBusinessPremisesRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Download a generated usage data CSV report for an organization
     * Download a generated usage data CSV report for an organization. 
* @param requestParameters
     */
    getCSVReportUsageOrganization(requestParameters: GetCSVReportUsageOrganizationRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Download the generated usage data CSV report for a tenant
     * Download the generated usage data CSV report for a selected tenant. 
* @param requestParameters
     */
    getCSVReportUsageTenant(requestParameters: GetCSVReportUsageTenantRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Download the generated usage data CSV report for the contract
     * Download the generated usage data CSV report for the contract. 
* @param requestParameters
     */
    getGeneratedCSVUsageCustomerByContractId(requestParameters: GetGeneratedCSVUsageCustomerByContractIdRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Download the generated usage data report for the contract
     * Download the generated usage data report for the contract. 
* @param requestParameters
     */
    getGeneratedUsageCustomerByContractId(requestParameters: GetGeneratedUsageCustomerByContractIdRequestParams, extraHttpRequestParams?: any): Observable<CustomerUsageContractDTO>;

    /**
     * Status of generating a usage data report
     * Status of generating a usage data report for a business premises. 
* @param requestParameters
     */
    getReportStatusUsageBusinessPremises(requestParameters: GetReportStatusUsageBusinessPremisesRequestParams, extraHttpRequestParams?: any): Observable<ReportStatusDTO>;

    /**
     * Status of generating a usage data report
     * Status of generating a usage data report for the contract. 
* @param requestParameters
     */
    getReportStatusUsageCustomerByContractId(requestParameters: GetReportStatusUsageCustomerByContractIdRequestParams, extraHttpRequestParams?: any): Observable<ReportStatusDTO>;

    /**
     * Status of generating a usage data report
     * Status of generating a usage data report for an organization. 
* @param requestParameters
     */
    getReportStatusUsageOrganization(requestParameters: GetReportStatusUsageOrganizationRequestParams, extraHttpRequestParams?: any): Observable<ReportStatusDTO>;

    /**
     * Status of generating a usage data report
     * Status of generating a usage data report for a selected tenant. 
* @param requestParameters
     */
    getReportStatusUsageTenant(requestParameters: GetReportStatusUsageTenantRequestParams, extraHttpRequestParams?: any): Observable<ReportStatusDTO>;

    /**
     * Download a generated usage data report for a business premises
     * Download a generated usage data report for a business premises. 
* @param requestParameters
     */
    getReportUsageBusinessPremises(requestParameters: GetReportUsageBusinessPremisesRequestParams, extraHttpRequestParams?: any): Observable<BusinessPremisesUsageContractDTO>;

    /**
     * Download a generated usage data report for an organization
     * Download a generated usage data report for an organization. 
* @param requestParameters
     */
    getReportUsageOrganization(requestParameters: GetReportUsageOrganizationRequestParams, extraHttpRequestParams?: any): Observable<OrganizationUsageContractDTO>;

    /**
     * Download the generated usage data report for a tenant
     * Download the generated usage data report for a selected tenant. 
* @param requestParameters
     */
    getReportUsageTenant(requestParameters: GetReportUsageTenantRequestParams, extraHttpRequestParams?: any): Observable<TenantUsageContractDTO>;

}
